import { Button } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AiFillMinusCircle } from 'react-icons/ai'
import { IoMdAddCircle, IoMdCreate } from 'react-icons/io'
import { MdOutlineClose } from 'react-icons/md'
import { useAppDispatch, useAppSelector } from '../../useStore'
import { createTest, reset } from '../../features/Test/testSlice'
import swal from "sweetalert";
import { Spinners } from '../TableOptions'

const CreateTest = ({ show, setShow }) => {

	const dispatch = useAppDispatch();
	const { isError, message, isLoading, isSuccess } = useAppSelector((state: { test: any; }) => state.test)


	useEffect(() => {
		if (isError) {
			swal({
				title: "error",
				text: message,
				icon: "error"
			})
			dispatch(reset())
		} else if (isSuccess) {
			swal({
				title: "success",
				text: message,
				icon: "success"
			})
			setInputs({
				"testTitle": "",
				"testDescription": "",
				"totalScore": "",
				"testQuestions": [""]
			})


			setShow(false)
			dispatch(reset())
		}
	}, [dispatch, isError, isSuccess, message, setShow])


	const [question, setQuestion] = useState<any>([{
		questions: ' ',
		a: ' ',
		b: ' ',
		c: ' ',
		d: ' ',
		correctAns: '',
		id: 1,
		ans: "",
		score: ""
	}],

	)


	const [inputs, setInputs] = useState({
		"testTitle": "",
		"testDescription": "",
		"totalScore": "",
		"testQuestions": [""]
	})



	const testQuestions = question?.map((item: any) => ({
		question: item.questions,
		optionA: item.a,
		optionB: item.b,
		optionC: item.c,
		optionD: item.d,
		score: item.score,
		correctAnswer: item.correctAns,
	}));

	const data = { ...inputs, testQuestions }


	const handleCreateTest = () => {
		// @ts-ignore
		dispatch(createTest(data));
	}


	// --- Adds New Performance Field --- //
	const handleAddField = () => {
		setQuestion([
			...question,
			{
				questions: '',
				a: '',
				b: '',
				c: '',
				d: '',
				correctAns: '',
				id: question.length + 1,
				ans: "",
				score: ""
			}
		]);
	};

	// --- Remove New Weekly Field   --- //
	const handleRemoveField = (index: any) => {
		const field = [...question];
		field.splice(index, 1);
		setQuestion(field);
	};


	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	const handleChange = (input: any, value: any, index: any,) => {
		let items = [...question];
		let oldItem = items.findIndex((x) => x.id === index);
		let newItem = { ...items[oldItem], [input]: value };
		items[oldItem] = newItem;
		setQuestion(items);
	};

	const handelmodalclose = () => {
		setShow(false)
		setQuestion([
			{
				questions: '',
				a: '',
				b: '',
				c: '',
				d: '',
				correctAns: '',
				id: 1,
				ans: "",
				score: ""
			}
		]);
	}

	return (
		<div>
			<Modal show={show} scrollable={true} backdrop="static" size="xl">
				<header className="ChatProgressView-header"  >
					<div className='Update-titile-icon'>
						<IoMdCreate color='#0a66c2' />
						<div className="in-progresss">
							Create Test
						</div>
					</div>

					<div className="ChatProgressView-close" onClick={handelmodalclose} >
						<MdOutlineClose
							size={25}
							style={{ color: "white", backgroundColor: "" }}
							className="ChatProgressView-close-icon"
						/>
					</div>
				</header>
				<Modal.Body>
					<div>
						<div className='AddJob_main_container_input'>
							<div style={{ width: "100%" }}>
								<h6 style={{ marginBottom: 10 }}>Test Title</h6>
								<input
									required
									type="text"
									className='AddJobinput'
									value={inputs?.testTitle}
									onChange={(e) => handleOnChange("testTitle", e.target.value)}
									placeholder='Test Title' />
							</div>

							<div style={{ margin: '20px' }} />
							<div style={{ width: "100%" }}>
								<h6 style={{ marginBottom: 10 }}>Test Duration</h6>
								<select
									required
									className="round"
									value={inputs?.totalScore}
									onChange={(e) => handleOnChange("totalScore", e.target.value)}>
									<option>Test Duration...</option>
									{["5", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55", "60"]?.map((item: any, i: any) => (
										<option key={i} value={item}  >
											{item} minutes
										</option>
									))}
								</select>
							</div>
						</div>

						<div className='AddJob_main_container_input'>
							<div style={{ width: "100%" }}>
								<h6 style={{ marginBottom: 10 }}>Test Description</h6>
								<input
									required
									type="text"
									className='AddJobinput' style={{ marginBottom: "15px", }}
									value={inputs?.testDescription}
									onChange={(e) => handleOnChange("testDescription", e.target.value)}
									placeholder='Test Discription' />
							</div>
						</div>

						{question.map((item: any, index: any) => (
							<div className='AddJob_main_sub_container' key={index}>

								<div className='handleAddField-icon' style={{ color: "#0b03fc" }}>	<h5 > Questions {index + 1}</h5>
									<div>
										{index === 0 ?
											<Button onClick={handleAddField}>
												<IoMdAddCircle size={25} className='Recruiting-tab-add-btn' />
											</Button> : <Button onClick={handleRemoveField}>
												<AiFillMinusCircle size={25} className='Recruiting-tab-add-btn1' />
											</Button>}</div>
								</div>

								<div className='AddJob_main_container_input'>
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }} >Test Questions {index + 1}</h6>

										<input
											required
											type="text"
											className='AddJobinput' style={{ marginBottom: "15px", }}
											value={item?.questions}
											onChange={(e) => handleChange("questions", e.target.value, item.id)}
											placeholder='Test Questions' />
									</div>
								</div>

								<div className='AddJob_main_container_input_two'>
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }}>Answer A</h6>

										<input
											required
											type="text"
											className='AddJobinput' style={{ marginBottom: "15px", }}
											value={item?.a}
											onChange={(e) => handleChange("a", e.target.value, item.id)}
											placeholder='Answer A' />

									</div>
									<div style={{ margin: '20px' }} />
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }}>Answer B</h6>
										<input
											required
											type="text"
											className='AddJobinput' style={{ marginBottom: "15px", }}
											value={item.b}
											onChange={(e) => handleChange("b", e.target.value, item.id)}
											placeholder='Answer B' />

									</div>
								</div>

								<div className='AddJob_main_container_input_two'>
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }}> Answer C </h6>
										<input
											required
											type="text"
											className='AddJobinput' style={{ marginBottom: "15px", }}
											value={item.c}
											onChange={(e) => handleChange("c", e.target.value, item.id)}
											placeholder='Answer C' />
									</div>
									<div style={{ margin: '20px' }} />
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }}>Answer D</h6>
										<input
											required
											type="text"
											className='AddJobinput' style={{ marginBottom: "15px", }}
											value={item.d}
											onChange={(e) => handleChange("d", e.target.value, item.id)}
											placeholder='Answer D' />
									</div>
								</div>

								<div className='AddJob_main_container_input_Checkbox'>
									<div style={{ width: "100%" }}>
										<h6 style={{ marginBottom: 10 }}>Correct Ans</h6>

										<select
											required
											className="round"
											value={item?.correctAns}
											onChange={(e) => handleChange("correctAns", e.target.value, item.id)}>
											<option>Correct Ans</option>
											{["optionA", "optionB", "optionC", "optionD"]?.map((item: any, i: any) => (
												<option key={i} value={item}  >
													{item}
												</option>
											))}
										</select>
									</div>
									<div style={{ margin: '20px' }} />
									<div style={{ width: "60%" }} className='check-contianer'>
									</div>
								</div>

							</div>
						))}

					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={handleAddField} style={{ border: "1px solid black", color: "#000" }} ><IoMdAddCircle size={25} className='Recruiting-tab-add-btn' />Add Test Question</Button>
					<div style={{ margin: '20px' }} />
					<Button onClick={handleCreateTest} className="view-HIRED-profile" disabled={isLoading}>{isLoading ? <Spinners size={"sm"} /> : "Create Test"}</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default CreateTest